import { Component, OnInit } from '@angular/core';
import { IContractEventLog, IContractPartnerChangeLog, IGenericContract } from 'src/app/models/generic';
import { ApiContractService } from 'src/app/services/api/api-contract.service';

@Component({
  selector: 'app-contrato-log',
  templateUrl: './contrato-log.component.html',
  styleUrls: ['./contrato-log.component.scss']
})
export class ContratoLogComponent implements OnInit {

  logs: IContractPartnerChangeLog[] = [];
  eventLogs: IContractEventLog[] = [];
  combinedLogs: any[] = [];
  contractData!: IGenericContract;
  isLoading = true;

  constructor(
    private _contractService: ApiContractService,
  ) { }

  ngOnInit(): void {
    this.contractData = this._contractService.contractData;

    const contractId = this.contractData?.ContractId;

    this._contractService.getContractHistory(contractId).subscribe({
      next: (res) => {
        this.logs = res.Data?.LogsChangePartnerContract ?? [];
        this.eventLogs = res.Data?.ContractEventLogs ?? [];
        this.combinedLogs = [...this.logs, ...this.eventLogs];

        this.combinedLogs.sort((a, b) => {
          const dateA = this.parseDateStringToDate((a.ChangeDateTimeFormatted || a.CreateDateString)).getTime();
          const dateB = this.parseDateStringToDate((b.ChangeDateTimeFormatted || b.CreateDateString)).getTime();
          return dateB - dateA;
        });

        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  parseDateStringToDate(dateString: string): Date {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('/');
    const [hour, minute] = timePart.split(':');

    // Subtraindo 1 do mês, já que no JavaScript os meses começam de 0 (janeiro é 0)
    const parsedDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute));

    return parsedDate;
  }

  isPartnerChangeLog(log: IContractPartnerChangeLog | IContractEventLog): log is IContractPartnerChangeLog {
    return !!(log as IContractPartnerChangeLog).ChangeDateTimeFormatted;
  }

  logDate(log: IContractPartnerChangeLog | IContractEventLog): string {
    const dateString = this.isPartnerChangeLog(log)
      ? log.ChangeDateTimeFormatted
      : log.CreateDateString;

    return (dateString || '').split(' ')[0] || '-';
  }

  logTime(log: IContractPartnerChangeLog | IContractEventLog): string {
    const dateString = this.isPartnerChangeLog(log)
      ? log.ChangeDateTimeFormatted
      : log.CreateDateString;

    return (dateString || '').split(' ')[1] || '';
  }

  logTitle(log: IContractPartnerChangeLog | IContractEventLog): string {
    if (this.isPartnerChangeLog(log)) {
      return 'Alteração de Parceiro';
    }

    const text = (log.Event || '').toLowerCase();
    const tipoLote = text.includes('lote de repasse') ? 'lote de repasse' : 'lote de faturamento';

    if (text.includes('exclu') || text.includes('removid')) {
      return `Removido do ${tipoLote}`;
    }
    if (text.includes('inserido')) {
      return `Inserido no ${tipoLote}`;
    }
    if (text.includes('importado') || text.includes('criado')) {
      return 'Contrato criado na esteira';
    }

    return 'Evento';
  }

  logDescription(log: IContractPartnerChangeLog | IContractEventLog): string {
    if (this.isPartnerChangeLog(log)) {
      return `Parceiro alterado de ${log.OldNamePartner || '-'} (${log.OldCNPJPartner || '-'}) para ${log.NewNamePartner || '-'} (${log.NewCNPJPartner || '-'}).`;
    }

    // Eventos antigos foram gravados com "ás" (sem crase); corrige na exibição.
    return (log.Event || '-').replace(/ ás /g, ' às ');
  }

  logTone(log: IContractPartnerChangeLog | IContractEventLog): 'danger' | 'info' | 'success' | 'neutral' {
    if (this.isPartnerChangeLog(log)) {
      return 'info';
    }

    const text = (log.Event || '').toLowerCase();

    if (text.includes('exclu') || text.includes('removid')) {
      return 'danger';
    }
    if (text.includes('inserido')) {
      return 'info';
    }
    if (text.includes('importado') || text.includes('criado')) {
      return 'success';
    }

    return 'neutral';
  }
}
